// src/layouts/RootLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar';
import Header from '../components/Header/Header';

const RootLayout = () => {
  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Header />
        <div className="p-4 bg-gray-100 overflow-y-auto">
          <Outlet /> {/* Nested routes render here */}
        </div>
      </div>
    </div>
  );
};

export default RootLayout;
